import { colors } from "../../styles/theme"
import { Driver } from "./types"

interface LeaderboardContentProps {
  drivers: Driver[]
}

export function LeaderboardContent({ drivers }: LeaderboardContentProps) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold" style={{ color: colors.text.primary }}>
          Driver Ladder Points
        </h2>
        <p className="text-sm mt-1" style={{ color: colors.text.secondary }}>
          Championship standings across all events and series
        </p>
      </div>
      
      {/* Leaderboard Table */}
      <div
        className="overflow-hidden border rounded-lg"
        style={{ backgroundColor: colors.background.tertiary, borderColor: colors.border.primary }}
      >
        <table className="min-w-full divide-y" style={{ borderColor: colors.border.primary }}>
          <thead style={{ backgroundColor: colors.background.secondary }}>
            <tr>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Rank
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Driver
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Race Number
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Points
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Events
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Wins
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Best ET
              </th>
              <th
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                style={{ color: colors.text.secondary }}
              >
                Best RT
              </th>
            </tr>
          </thead>
          <tbody className="divide-y" style={{ borderColor: colors.border.primary }}>
            {drivers.map((driver, index) => (
              <tr key={driver.id} className="hover:opacity-80">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div
                      className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                        index === 0
                          ? "text-yellow-400"
                          : index === 1
                            ? "text-gray-300"
                            : index === 2
                              ? "text-orange-400"
                              : ""
                      }`}
                      style={{
                        backgroundColor:
                          index < 3 ? colors.background.secondary : colors.background.tertiary,
                        color:
                          index === 0
                            ? colors.status.warning
                            : index === 1
                              ? colors.text.secondary
                              : index === 2
                                ? "#fb923c"
                                : colors.text.tertiary,
                      }}
                    >
                      {index + 1}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium" style={{ color: colors.text.primary }}>
                    {driver.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm" style={{ color: colors.text.primary }}>
                    {driver.race_number || '-'}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-semibold" style={{ color: colors.primary[400] }}>
                    {driver.total_points}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm" style={{ color: colors.text.primary }}>
                    {driver.events_participated}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm" style={{ color: colors.text.primary }}>
                    {driver.wins}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-mono" style={{ color: colors.text.primary }}>
                    {driver.best_et?.toFixed(3) || '0.000'}s
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-mono" style={{ color: colors.text.primary }}>
                    {driver.best_rt?.toFixed(3) || '0.000'}s
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Points System Info */}
      <div
        className="mt-6 p-4 border rounded-lg"
        style={{ backgroundColor: colors.status.info + "10", borderColor: colors.status.info + "40" }}
      >
        <h4 className="text-sm font-medium mb-2" style={{ color: colors.status.info }}>
          Dynamic Points System
        </h4>
        <div className="text-xs space-y-1" style={{ color: colors.text.secondary }}>
          <div>• Bracket points follow the stage a driver went out in, counted back from the final</div>
          <div>• Winner: 150 | Runner-up: 130 | Semi-final: 110 | Quarter-final: 90 | 1/8: 70 | 1/16: 50 | 1/32: 30 | 1/64: 10</div>
          <div>• From the 2026 season: Round 1: 15 pts | Ready to Compete: 5 pts | Best reaction time: 7 pts (11 for a perfect 0.000)</div>
          <div>• Bonuses count once per driver, so a re-entry never doubles them</div>
          <div>• 2025 race days keep their own ladder: points by finishing position, no bonuses</div>
          <div>• Series points accumulated across the dates of one season</div>
        </div>
      </div>
    </div>
  )
} 